import { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router';
import { Skeleton } from '@/component/Skeleton';
import {
  activitiesPath,
  equipmentPartsPath,
  noticeBoardPath,
  screenActivityPath,
} from '../pathDefinitions';
import FleetOverview from './FleetOverview';

const ActivityRoutes = lazy(() => import('./activity/ActivityRoutes'));
const ScreenActivityDetails = lazy(
  () => import('@/feature/deckmapp/fleet/screenActivity/ScreenActivityDetails')
);
const Catalog = lazy(() => import('../ecom/catalog/content/Catalog'));
const ClaimDetails = lazy(() =>
  import('./basics/claims/details/ClaimDetails').then((module) => ({
    default: module.ClaimDetails,
  }))
);
const NotificationDetails = lazy(
  () => import('./messages/NotificationDetails')
);

export const notificationIdParam = 'notificationId';
export const activityIdParam = 'activityId';
export const equipmentIdParam = 'equipmentId';
export const screenActivityIdParam = 'screenActivityId';
export const claimIdParam = 'claimId';
export const claimPath = 'claim';

export default function FleetRoutes() {
  return (
    <Suspense
      fallback={<Skeleton sx={{ m: 2, height: 36 }} variant="rectangular" />}
    >
      <Routes>
        <Route path="/*" element={<FleetOverview />} />
        <Route
          path={`${equipmentPartsPath}/catalog/:catalogId`}
          element={<Catalog />}
        />
        <Route
          path={`${noticeBoardPath}/:${notificationIdParam}`}
          element={<NotificationDetails />}
        />
        <Route
          path={`${activitiesPath}/:${activityIdParam}/*`}
          element={<ActivityRoutes />}
        />
        <Route
          path={`${activitiesPath}/${screenActivityPath}/:${equipmentIdParam}/:${screenActivityIdParam}`}
          element={<ScreenActivityDetails />}
        />
        <Route
          path={`${claimPath}/:${claimIdParam}`}
          element={<ClaimDetails />}
        />
      </Routes>
    </Suspense>
  );
}
